import { Point } from "PosterEditor/model/poster-types";

export const drawPointerHighlightPoints = (
  points: Point[],
  ctx: CanvasRenderingContext2D,
  closestPointToCursor?: Point
) => {
  const strokeStyle = "#FFFFFF";
  const fillStyle = "#000000";

  const lineWidth = 1;
  const lineWidthForClosestPoint = 2;

  const radius = 3;
  const radiusForClosestPoint = 10;

  ctx.setLineDash([]);
  points.forEach((point) => {
    let isClosestPoint = false;
    if (
      closestPointToCursor &&
      closestPointToCursor.x === point.x &&
      closestPointToCursor.y === point.y
    ) {
      isClosestPoint = true;
    }
    ctx.beginPath();
    ctx.strokeStyle = strokeStyle;
    ctx.fillStyle = fillStyle;

    ctx.lineWidth = isClosestPoint ? lineWidthForClosestPoint : lineWidth;
    ctx.arc(
      point.x,
      point.y,
      isClosestPoint ? radiusForClosestPoint : radius,
      0,
      Math.PI * 2
    );
    ctx.fill();

    ctx.stroke();
  });
};
